import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';

// APIs
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalRevisionOperaciones = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [loading, setLoading] = useState(false);
    const [razon, setRazon] = useState(props.data.razonRevisionOperaciones ? props.data.razonRevisionOperaciones : undefined);

    const razones = [
        'POR AVAL DEL ÁREA SOCIAL',
        'POR TEMAS DE LA COMUNIDAD',
        'POR APROBACIÓN DEL CLIENTE',
        'POR DEFINICIÓN DE UN CAMPO DE CONDICIÓN',
        'POR VALIDACIÓN DE HOJAS DE VIDA'
    ];

    const updateAPE = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                razonRevisionOperaciones: razon ?? '',
                cmp_stat: 'PRUEBAS'
            },

        }
        try {
            await actualizarAPE(body)
            props.updateAPE({
                estadoAPE: 'LISTA_CHEQUEO'
            })
            props.toastSuccess('APE actualizada!')
        }
        catch (error) {
            console.log(error)
            props.toastError('Hubo un error!')
        }
    }
    const handleStateUpdate = async () => {
        await updateAPE()
        props.toggle()
    }

    const renderBody = () => {
        return (
            <div>
                <div>
                    <Row style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        {/* <Col lg='3' md='3' xs='12'>
                            <TextField
                                variant='outlined'
                                required
                                type='time'
                                autoComplete='off'
                                key={`hora`}
                                id={`hora`}
                                fullWidth
                                margin='normal'
                                onChange={(e) => { actualizarObjetoCreacion(e.target.id, e.target.value) }}
                                // onChange={(e) => { console.log(e.target.id, e.target.value) }}
                            />
                        </Col> */}
                        <Col lg='4' md='4' xs="12" className='informe-final-select'>
                            <Autocomplete
                                required
                                margin="dense"
                                options={razones}
                                key={`key_TipoDeContrato`}
                                id={`select_TipoDeContrato`}
                                onChange={(event, newValue) => setRazon(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label={'Razón'} margin="normal" />
                                )}
                                getOptionLabel={(option) => option}
                                renderOption={(option) => (
                                    <React.Fragment>
                                        {option}
                                    </React.Fragment>
                                )}
                            />
                        </Col>
                        {/* <Col lg='6' md='6' xs='12'>
                            <TextField
                                key='lugar'
                                id='lugar'
                                autoComplete='off'
                                variant='outlined'
                                select
                                fullWidth
                                margin='normal'
                                label="Lugar"
                                onChange={(e) => { console.log('lugar', e.target.value) }}
                            >
                                {lugares.map((lugar) => (
                                    <MenuItem key={lugar.id} value={lugar.nombre}>
                                        {lugar.nombre}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Col> */}
                        {/* <Col lg='6' md='6' xs='12'>
                            <TextField
                                variant='outlined'
                                required
                                key={`correo`}
                                id={`correo`}
                                fullWidth
                                label='Email'
                                margin='normal'
                                disabled
                                defaultValue={candidatoActivo.correo ?? '--'}
                            />
                        </Col> */}
                    </Row>
                </div>
            </div>
        )
    }

    if (loading) { return <div className={'loading-area'}> <Loading /> </div> }
    else return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Aceptar'}
                onClick={() => { handleStateUpdate() }}
                buttonLoading={!(razon !== undefined)}
                title={`Revisión Operaciones`}
            >
                {renderBody()}
            </CustomModal>
        </React.Fragment>
    );

}

export default connect(mapStateToProps)(ModalRevisionOperaciones);